import Footer from "../../../components/Footer/Footer";
import NavBar from "../../../components/NavBar/NavBar";

import Title from "../../../components/Title/Title";
import CustomButton from "../../../components/Custom-Button/CustomButton";
export default function SixthCommandment() {

    return (
        <div>
            <NavBar/>
            <Title text={"Não Pecar Contra a Castidade "}/>

            <p className="info-text">
            Este mandamento é entendido pela Igreja como abrangendo toda a moralidade sexual. Do ponto de vista teológico, Deus criou o homem e a mulher à Sua imagem para uma união de amor e vida[62][63]. <br/>
            A sexualidade humana toca a capacidade de amar e procriar (Gn 1,27-28)[62]. <br/>
            O CIC explicita que o matrimônio entre um homem e uma mulher imita a generosidade do Criador[63]. <br/>
            Jesus interpreta o mandamento severamente: proibindo até mesmo o desejo impuro (“Todo aquele que olhar para uma mulher desejando-a já cometeu adultério no coração”[64]). <br/>
            A Igreja ensina que a castidade (domínio dos desejos sexuais) é dever de todos: os casados devem viver a castidade conjugal (fé fidelidade e abertura à vida), os solteiros praticam a continência[65]. <br/>
            A castidade íntegra a pessoa, harmonizando corpo e alma[65][66], enquanto a luxúria desordena essa harmonia.
            </p> 

            <Title text={"Aplicação Cotidiana"}/>
            <p className="info-text">
            Na vida diária, este mandamento chama à fidelidade conjugal e à pureza de coração. <br/>
            Os casados devem ser fiéis um ao outro, educando sua afetividade e cuidando da sua vida sexual conforme os valores cristãos (evitando contracepção que separa os fins do sexo, por exemplo). <br/>
            Quem não é casado deve abster-se de relações sexuais, vivendo a virtude da castidade (o que inclui a moderação de olhares e comportamentos sensuais)[64][67]. <br/>
            Em qualquer estado, deve-se evitar revistas eróticas, conversas ou imagens impuras e gestos de sensualidade indevidos, praticando o pudor[68][69]. <br/>
            Educar as novas gerações no respeito ao próprio corpo e ao ajuramento de pureza é outra aplicação essencial. <br/>
            No casamento cristão, a total entrega mútua (o “só a Ele darás culto” do matrimônio) e a abertura aos filhos concretizam este mandamento
            </p> 

            <Title text={"Aspectos Teológicos"}/>
            Sexualidade é dom de Deus vinculado ao plano criador. O CIC ensina que homem e mulher têm dignidade igual, e no matrimônio alcançam sua realização comum[62][63]. <br/>
            O mandamento protege o matrimônio como sacramento do amor de Cristo pela Igreja: “o que Deus uniu, não separe o homem” (Mt 19,6)[64]. <br/>
            A batalha espiritual contra a concupiscência é reconhecida no Catecismo: a concupiscência vem do pecado original e exige purificação do coração[67][70]. <br/>
            Além disso, este mandamento proíbe todas as formas de degradação da sexualidade: exploração, pornografia, prostituição, relações homossexuais, fora do matrimônio – atos que a Igreja considera contrários à dignidade humana do sexo. <br/>
            Em contrapartida, a castidade e o amor conjugal são meios de santificação e refletem o mistério da Cruz (onde o amor vence a desordem), como ensina São Paulo (1Co 7). <br/>
            Em suma, o mandamento mostra que a afetividade deve ser vivida sob o sinal do dom fiel de Deus e do amor responsável.<br/>
            <p className="info-text">

            </p> 

            <CustomButton route={"/Mandamentos"} text={"Voltar"}/>
            <Footer/>
        </div>
    )
}